import { useMediaQuery } from 'react-responsive';

const breakpoints = {
  mobile: {
    lower: null,
    upper: 767,
  },
  tablet: {
    lower: 768,
    upper: 991,
  },
  desktop: {
    lower: 992,
    upper: 1199,
  },
  wide: {
    lower: 1200,
    upper: null,
  },
};

export function Mobile({ children }) {
  const isMobile = useMediaQuery({
    maxWidth: breakpoints.mobile.upper,
  });
  return isMobile ? children : null;
}

export function Tablet({ children }) {
  const isTablet = useMediaQuery({
    minWidth: breakpoints.tablet.lower,
    maxWidth: breakpoints.tablet.upper,
  });
  return isTablet ? children : null;
}

export function Desktop({ children }) {
  const isDesktop = useMediaQuery({
    minWidth: breakpoints.desktop.lower,
    maxWidth: breakpoints.desktop.upper,
  });
  return isDesktop ? children : null;
}

export function Wide({ children }) {
  const isWide = useMediaQuery({
    minWidth: breakpoints.wide.lower,
  });
  return isWide ? children : null;
}

export function DesktopUp({ children }) {
  const isDesktopUp = useMediaQuery({
    minWidth: breakpoints.desktop.lower,
  });
  return isDesktopUp ? children : null;
}

export function DesktopDown({ children }) {
  const isDesktopDown = useMediaQuery({
    maxWidth: breakpoints.tablet.upper,
  });
  return isDesktopDown ? children : null;
}

export function WideUp({ children }) {
  const isWideUp = useMediaQuery({
    minWidth: breakpoints.wide.lower,
  });
  return isWideUp ? children : null;
}

export function WideDown({ children }) {
  const isWideDown = useMediaQuery({
    maxWidth: breakpoints.desktop.upper,
  });
  return isWideDown ? children : null;
}
